import { ref as o } from "vue";
import { isColumnResizable as s } from "./ghl-ui.es996.js";
function u() {
  const i = o({});
  function t(e) {
    return i.value[e];
  }
  function r(e, n) {
    s(e) && "key" in e && (i.value[e.key] = n);
  }
  function a() {
    i.value = {};
  }
  return {
    getResizableWidth: t,
    doUpdateResizableWidth: r,
    clearResizableWidth: a
  };
}
export {
  u as useResizable
};
